import React from "react";
import { Link } from "react-router-dom";

const CategoryTile = ({ category }) => (
    <Link
        to={`/products?category=${category.slug}`}
        className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-zinc-100 bg-white transition-all hover:-translate-y-1 hover:border-brand-200 hover:shadow-brand"
        data-testid={`category-tile-${category.slug}`}
    >
        <div className="relative aspect-[4/3] w-full overflow-hidden bg-brand-50">
            <img
                src={category.image_url || "/pills-logo.jpg"}
                alt={category.name}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/0 to-black/0" />
        </div>
        <div className="flex items-center justify-between p-4">
            <div>
                <p className="text-sm font-medium text-zinc-900">{category.name}</p>
                <p className="text-xs text-zinc-500">Browse range →</p>
            </div>
            <span className="rounded-full bg-brand-50 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-brand-700">
                {category.icon_emoji || "•"}
            </span>
        </div>
    </Link>
);

export default CategoryTile;
